import LeftRightContentBanner from "./leftRightContentBanner";

export default LeftRightContentBanner;